import React from 'react';

import { WebPlayerContext } from './WebPlayerContext';

export const useWebPlayerContext = () => React.useContext(WebPlayerContext);
